import ListCell from '@doordash/component-list-cell'
import { Text } from '@doordash/design-language'
import * as React from 'react'

const Cell = ({ isToggled, isDesktopWidth, ...props }) => {
  const cellToggled = isDesktopWidth ? false : isToggled
  const cellIcon = cellToggled
    ? { type: ListCell.IconTypes.ChevronUp }
    : { type: ListCell.IconTypes.ChevronDown }
  return (
    <ListCell
      size={ListCell.Sizes.Large}
      accessibilityRole="checkbox"
      accessibilityLabel={props.title}
      titleMaxLines={6}
      subtextMaxLines={1}
      isToggled={cellToggled}
      isSeparatorVisible={false}
      iconEnd={isDesktopWidth ? null : cellIcon}
      renderBelowContent={() => (
        <ul>
          {isToggled &&
            props.bodytext.map((text, idx) => (
              <li key={`cell${idx}${text}`}>
                <Text styles={Text.Styles.ContentBody}>{text}</Text>
              </li>
            ))}
        </ul>
      )}
      {...props}
    />
  )
}

export default Cell
